module.exports = __webpack_public_path__ + "img/icon-dropdown-white.09854286.svg";